// extracted by mini-css-extract-plugin
module.exports = {"container":"sportsNavigation__container___2EJq2","is-compact":"sportsNavigation__is-compact___5D-5k"};